/* class definitions 
.error = django error
.js-error = frontend error
.warning = input breached expected min/max values
.locked = input is readonly, styled grayscale
.disabled = element is disabled, styled grayscale
*/

/* variables */
let jsonData; //for later
let presets; //for later
let inputs; //for later 
let outputs; //for later 
let prevBedroomValues = [0, 0, 0, 0, 0, 0];
let gfx_ext = "";
let MultiPassLSElement;
let SinglePassLSElement


function isNotEmpty(value) {
    if (value == null || value.length === 0) {
        return false;
    }
    return true;
}

function lockFields(fields) {
    Object.keys(fields).forEach(function (i) {
        /* check if field exists */
        if ($(`input[name=${fields[i]}]`).length != 0) {

            $(`input[name=${fields[i]}]`).prop({
                'readonly': true,
                "tabindex": "-1"
            }).parents(".field-wrap").addClass("locked").removeClass("js-error warning warning-expmin warning-expmax");
        }
    });
}

function unlockFields(fields) {
    Object.keys(fields).forEach(function (i) {
        /* check if field exists */
        if ($(`input[name=${fields[i]}]`).length != 0) {

            $(`input[name=${fields[i]}]`).prop({
                'readonly': false,
                "tabindex": ""
            }).parents(".field-wrap").removeClass("locked");
        }
    });
}

function populateField(key, properties) {
    const inputType = key === "buildingType" ? 'select' : 'input'
    const inputFields = $(inputType + "[name=" + key + "]", "#form_ecosizer");
    let inputField = "";
    let inputField2 = "";

    // Using 2 input fields twice so need to loop through and add same info twice
    for (var i = 0; i < inputFields.length; i++) {
        let inputField = $( inputType + '[name=' + key + ']', '#form_ecosizer')[i];

        const inputID = $(inputField).attr('id');
        const fieldWrap = $(inputField).parents('.field-wrap')[0];
        if (!fieldWrap) return;

        // Second input won't have label as it is used in Load Shift table
        if($('label', fieldWrap).length > 0) {
            let label = (properties.label_trunc ? properties.label_trunc : $('label', fieldWrap).html());
            $('label', fieldWrap).html(label).attr("for", inputID);
        }

        /* add warning/error labels for later, make sure to insert only one instance */
        if ($('.suffix-wrap .label-warning', fieldWrap).length == 0) {
            $('.suffix-wrap', fieldWrap).append(`<p class="label-warning"><i class="symbol help left"><object tabindex="-1" type="image/svg+xml" data="/static/build/gfx/svg/symbol-warning${gfx_ext}.svg"></object><object class="help-hover" tabindex="-1" type="image/svg+xml" data="/static/build/gfx/svg/symbol-warning-hover${gfx_ext}.svg"></object></i>Warning</p>`);
        }
        if ($('.suffix-wrap .label-error', fieldWrap).length == 0) {
            $('.suffix-wrap', fieldWrap).append(`<p class="label-error"><i class="symbol help left"><object tabindex="-1" type="image/svg+xml" data="/static/build/gfx/svg/symbol-error${gfx_ext}.svg"></object><object class="help-hover" tabindex="-1" type="image/svg+xml" data="/static/build/gfx/svg/symbol-error-hover${gfx_ext}.svg"></object></i>Error</p>`);
        }

        if (properties.desc) {
            /* get description, if definition, wrap in link to launch help panel */
            let description = properties.desc;
            /* if definition available and desc does not have class = no-help */
            if (properties.definition && !($('p.desc', fieldWrap).hasClass('no-help'))) {
                let helpIcon = `<i class="symbol help left"><object tabindex="-1" type="image/svg+xml" data="/static/build/gfx/svg/symbol-help${gfx_ext}.svg"></object><object class="help-hover" tabindex="-1" type="image/svg+xml" data="/static/build/gfx/svg/symbol-help-hover${gfx_ext}.svg"></object></i>`;
                description = `<span>${helpIcon}${description}</span>`;

                $('.suffix-wrap', fieldWrap).attr('data-help', `inputs-${key}`);
            }

            /* if tag exists */
            if ($('p.desc', fieldWrap).length) {
                $('p.desc', fieldWrap).html(description);
            }
        }

        /* make sure inputs have min/max attributes */
        /* only include number inputs, not: 'select', 'range', 'text', 'email' */
        const includeTypes = ['number'];
        if (includeTypes.includes($(inputField).attr('type'))) {
            // hasMin = $(inputField).attr('min');
            // hasMax = $(inputField).attr('max');

            /* add placeholder for min/max errors */
            $('.suffix-wrap', fieldWrap).append(`<p class="js-errors"></p>`);

            if (isNotEmpty(properties.AbsMin)) {
                $(inputField).attr('min', properties.AbsMin);
            }
            if (isNotEmpty(properties.AbsMax)) {
                $(inputField).attr('max', properties.AbsMax);
            }

            if (isNotEmpty(properties.ExpMin) && isNotEmpty(properties.warningMin)) {
                $(inputField).attr('data-expmin', properties.ExpMin);
            }
            if (isNotEmpty(properties.ExpMax) && isNotEmpty(properties.warningMax)) {
                $(inputField).attr('data-expmax', properties.ExpMax);
            }
        }

        /* if input has no value and default exists in JSON set it */
        let inputValue = $(inputField).val();
        if (!inputValue && isNotEmpty(properties.default)) {
            $(inputField).val(properties.default);
        }
    }
    // TODO apply more based on preset values
}

/* Peak Gallons per Day per Person */
function userGPDBR(selected_value) {
    var presetValue;
    if (!selected_value) {
        selected_value = $('#id_gpdppptionsBR', '#form_ecosizer').find(":selected").val();
    }

    if (selected_value == "user") {
        setWaterSliders();
        return;
    } else if (selected_value == "ecoMark") {
        presetValue = presets.GPDPP.MarketRate.value;
        /* toggle */
        setWaterSliders(presetValue);
    } else if (selected_value == "ashLow") {
        presetValue = presets.GPDPP.ASHRAE_Low.value;
        /* toggle */
        setWaterSliders(presetValue);
    } else if (selected_value == "ashMed") {
        presetValue = presets.GPDPP.ASHRAE_Medium.value;
        /* toggle */
        setWaterSliders(presetValue);
    } else if (selected_value == "ca") {

        /* if already toggled reset GPDPP select menu */
        if ($("#toggle-ca_bedroom").hasClass('toggled')) {
            $("#id_gpdppptionsBR", '#form_ecosizer')[0].selectedIndex = 0;
            setWaterSliders();
            return;
        }

        $('#id_gpdppptionsBR', '#form_ecosizer').val(selected_value);

        /* untoggle */
        lockWaterSliders();

        $('#id_RBR_presets', '#form_ecosizer').val("CA");
        userRatioPeoplePerBedroom("CA");

        /* disable input fields  */
        disableRBR_fields();

        return; //exit 
    }

    /* assign the value to all gBR[i] inputs */
    $('[name^="gBR"]', '#form_ecosizer').each(function () {
        $(this).val(presetValue);
    });
}

$(document).on("change", '#form_ecosizer [name="gpdppptionsBR"]', function (e) {
    userGPDBR();
});

function enableRBR_fields() {
    /* restore input fields  */
    let fields = [];
    $('[name^="rBR"]', '#form_ecosizer').each(function () {
        fields.push(this.name);
    });
    unlockFields(fields);
    $('#id_RBR_presets', '#form_ecosizer').prop("disabled", false);
}

function disableRBR_fields() {
    /* lock input fields  */
    let fields = [];
    $('[name^="rBR"]', '#form_ecosizer').each(function () {
        fields.push(this.name);
    });
    lockFields(fields);
    $('#id_RBR_presets', '#form_ecosizer').prop("disabled", true);
}

/////////////////////////////////////////////////////////////////////////// 
/* Occupancy Rate */
function userRatioPeoplePerBedroom(selected_value) {
    if (!selected_value) {
        selected_value = $('#id_RBR_presets', '#form_ecosizer').find(":selected").val();
    }

    var ratioN; /* get values from JSON */
    if (selected_value == "user") {
        return; //exit
    } else if (selected_value == "ASHSTD") {
        ratioN = presets.RBR.ASHSTD.value;
    } else if (selected_value == "ASHLOW") {
        ratioN = presets.RBR.ASHLOW.value;
    } else if (selected_value == "CA") {
        ratioN = presets.RBR.CA.value;
    } else if (selected_value == "CTCAC") {
        ratioN = presets.RBR.CTCAC.value;
    }

    /* loop through input fields and values */
    $('[name^="rBR"]', '#form_ecosizer').each(function (index) {
        $(this).val(ratioN[index]);
        $(this).parents('.field-wrap').removeClass('error');
    });
}
//userRatioPeoplePerBedroom();
$(document).on("change", '#form_ecosizer [name="RBR_presets"]', function (e) {
    userRatioPeoplePerBedroom();
});
// And do the reverse if a user changes the option
$(document).on("change", '#form_ecosizer input[name^="rBR"]', function (e) {
    $('[name="RBR_presets"]', '#form_ecosizer').val("user");
});

function getInputValue(input_name) {
    return $('input[name=' + input_name + ']', '#form_ecosizer').val();
}

function setupFields() {
    /* setup toggled fields based on page load */

    /* on page load, add class to selected radios */
    // $('.radio-group input:radio').each(function (i) {
    //     if ($(this).is(':checked')) {
    //         $(this).parents('.btn-radio').addClass('toggled');            
    //     }
    // });    

    /* initialize sliders */
    $('.slider-water').each(function () {
        /* foreach slider instance, get related input field values and then initialize */
        const inputField = $(this).parents('.field-wrap').find('input');
        const minVal = Number($(inputField).attr('min'));
        const maxVal = Number($(inputField).attr('max'));
        const curVal = Number($(inputField).val());

        let sliderID = $(this).attr('id');
        sliderID = document.getElementById(sliderID);

        noUiSlider.create(sliderID, {
            /* https://refreshless.com/nouislider/ */
            range: {
                'min': minVal,
                'max': maxVal
            },
            step: 1,
            // Handle starts at ...
            start: [curVal],
            // Display colored bars between handles
            connect: [true, false],
            behaviour: 'tap-drag',
            tooltips: true,
            pips: {
                mode: 'values',
                values: [minVal, maxVal],
                filter: function (value) {
                    if (value === minVal || value === maxVal) {
                        return 1; //make value large size 
                    }
                    return -1; //no pip 
                }
            },
            format: {
                // 'to' the formatted value. Receives a number.
                to: function (value) {
                    return Number(Math.floor(value));
                },
                // 'from' the formatted value.
                // Receives a string, should return a number.
                from: function (value) {
                    return Number(Math.floor(value));
                }
            }
        });

        sliderID.noUiSlider.on('update', function (values) {
            const parent = $(this.target).parent('.field-wrap');
            //$('input', parent).val(values).trigger('change');
            $('input', parent).val(values).change();
        });

        sliderID.noUiSlider.on('set', function (values) {
            const parent = $(this.target).parent('.field-wrap');
            checkMinMax($('input', parent));
        });

        sliderID.noUiSlider.on('slide', function () {
            /* listen for user events */
            $('[name="gpdppptionsBR"]', '#form_ecosizer').val("user");
        });

    });

    /* add presets to all gallons per day sliders */
    let gpdpp_presets = '<div class="presets"><div class="preset text-tiny" data-value="' + presets.GPDPP.ASHRAE_Low.value + '" style="left:' + presets.GPDPP.ASHRAE_Low.pos + ';"><span>' + presets.GPDPP.ASHRAE_Low.label + '</span></div>';
    gpdpp_presets += '<div class="preset larger text-tiny" data-value="' + presets.GPDPP.MarketRate.value + '" style="left:' + presets.GPDPP.MarketRate.pos + ';"><span>' + presets.GPDPP.MarketRate.label + '</span></div>';
    gpdpp_presets += '<div class="preset text-tiny" data-value="' + presets.GPDPP.ASHRAE_Medium.value + '" style="left:' + presets.GPDPP.ASHRAE_Medium.pos + ';"><span>' + presets.GPDPP.ASHRAE_Medium.label + '</span></div></div>';
    $('.slider-water .noUi-pips').prepend(gpdpp_presets);

    /* check for california spec */
    if ($('input[name=CAspec]', '#form_ecosizer').is(':checked')) {
        CA_spec_mode(true);
    } else {
        /* if california spec not set, setup InputMethod based on set value */
        toggleInputMethod();
        userGPDBR();
    }
    
    /* btn-help */
    $('.btn-help').each(function () {
        $(this).append(`<i class="symbol help"><object tabindex="-1" type="image/svg+xml" data="/static/build/gfx/svg/symbol-help${gfx_ext}.svg"></object><object class="help-hover" tabindex="-1" type="image/svg+xml" data="/static/build/gfx/svg/symbol-help-hover${gfx_ext}.svg"></object></i>`);
    });
    
    setupSchematic();

    initRLHLmethod();

    /* if custom load method selected, toggle selected radios */
    if ($('input[name="customLoadMethod"]').length != 0) {
        let method = $('input[name="customLoadMethod"]').val();
        $(`input:radio[value=${method}]`).prop('checked', true);
        $(`input:radio[value=${method}]`).parents('.btn-radio').addClass('toggled');
        customLoadOptions(method);
    }

    /* if viewing errors or results, expand advanced options */
    // if ($('#form_ecosizer').is('.output-errors, .output-results')) {
    if ($('#form_ecosizer').is('.output-errors')) {
        $('.advanced-options').addClass("expanded");

        /* for number inputs, run the min/max validation on output, not on first page load */
        $('input[type=number]').each(function () {
            checkMinMax(this);
        });
    }

    /* if advanced options are expanded toggle btn */
    $('.advanced-options').each(function () {
        if ($(this).hasClass('expanded')) {
            $(this).find('.btn.js-adv-options').addClass("toggled");
        }
    });

    /* loadshift */
    const loadshift = $('input[name=loadShift]', '#form_ecosizer');
    if ($(loadshift).is(':checked')) {
        toggleLoadshift(true);
    }

}

function CA_spec_mode(toggle_on) {
    /* California Specification mode */
    const inputField = $('input[name=CAspec]', '#form_ecosizer');
    const button = $("#toggle-ca_spec");

    toggle_on = toggle_on !== undefined ? toggle_on : !$(inputField).is(':checked')

    if (toggle_on) {
        $(inputField).attr('checked', true);
        $(button).addClass("toggled");
        $("#toggle-ca_bedroom").prop({
            'disabled': 'disabled'
        });

        /* let's begin, toggle relevant fields */
        $('input[name=inputmethod]', '#form_ecosizer').val(""); //wash preset value
        toggleInputMethod('RPep');
        $('.js-btn-option[data-value=NPep]', '#form_ecosizer').prop("disabled", 'disabled');

        /* set sliders */
        $("#toggle-ca_bedroom").removeClass('toggled');
        userGPDBR("ca");
        $('#id_gpdppptionsBR', '#form_ecosizer').prop("disabled", 'disabled');

        /* populate fields with default California values */
        if (isNotEmpty(inputs.supplyT.default_CA)) {
            $('input[name=supplyT]').val(inputs.supplyT.default_CA);
            lockFields(['supplyT']);
        }
    } else {
        $(inputField).attr('checked', false);
        $(button).removeClass("toggled");
        $('.js-btn-option', '#form_ecosizer #fs-inputmethod').prop("disabled", false);
        $("#toggle-ca_bedroom").prop({
            'disabled': false
        });
        $('#id_gpdppptionsBR', '#form_ecosizer').prop("disabled", false);

        /* reset sliders */
        userGPDBR();
        unlockFields(['supplyT']);
    }
}

function setupSchematic(schematic_value) {
    let annual_value = undefined;
    let tempSchmaticVal = schematic_value;
    const primaryHPWHChoices = ['single_pass', 'multi_pass'];
    const tempMaintChoices = ['swingtank', 'paralleltank', 'singlepass_norecirc', 'sprtp', 'multipass_norecirc', 'mprtp'];

    const primaryConfig = {
        "single_pass": ['swingtank', 'paralleltank', 'singlepass_norecirc', 'sprtp'],
        "multi_pass": ['multipass_norecirc', 'mprtp']
    };

    const input_field = $('input[name="schematic"]', '#form_ecosizer');
    const fieldSet = $(input_field).parents('fieldset');
    const input_primaryHpwhConfig = $('input[name=primaryHPWHConfig]', '#form_ecosizer').length != 0 ? $('input[name=primaryHPWHConfig]', '#form_ecosizer') : undefined;
    /* reset all btns */
    // This really needs to be refactored to do if logic of one or other Primary HPWH config or temp maint
    // if single/multi then reset that button group else reset the temperature maint system button group
    if (schematic_value) {
        if (primaryHPWHChoices.indexOf(schematic_value) > -1) {
            $(`a[data-value="${primaryHPWHChoices[0]}"], a[data-value="${primaryHPWHChoices[0]}"] .btn`).removeClass('toggled');
            $(`a[data-value="${primaryHPWHChoices[1]}"], a[data-value="${primaryHPWHChoices[1]}"] .btn`).removeClass('toggled');
        }else if (tempMaintChoices.indexOf(schematic_value) > -1) {
            for (let i =0; i< tempMaintChoices.length; i++) {
                $(`a[data-value="${tempMaintChoices[i]}"], a[data-value="${tempMaintChoices[i]}"] .btn`).removeClass('toggled');
            }
        }
    } else {
        // This is when page inits
        $('.js-schematic-btn, .js-schematic-btn .btn').removeClass("toggled");
    }
    
    // page init
    if (!schematic_value) {
        /* get initial value from input and update HTML */
        // Use local temp var schematic value to keep schematic_value constant
        tempSchmaticVal = $(input_field).val();
        // set schmatic value initial button
        $(`a[data-value='${tempSchmaticVal}'], a[data-value='${tempSchmaticVal}'] .btn`).toggleClass('toggled').trigger('blur');

        if (input_primaryHpwhConfig) {
            annual_value = input_primaryHpwhConfig.val();
            $(`a[data-value='${annual_value}'], a[data-value='${annual_value}'] .btn`).toggleClass('toggled').trigger('blur');
            if(annual_value ==='single_pass') {
                $('#HPWHModel_single_pass').removeClass('d-none');
                $('#HPWHModel_multi_pass').addClass('d-none'); 
            } else if (schematic_value === "multi_pass") {
                $('#HPWHModel_single_pass').addClass('d-none');
                $('#HPWHModel_multi_pass').removeClass('d-none');
            }
        }
    } else {
        /* assign value to schematic input */
        if (primaryHPWHChoices.indexOf(schematic_value)> -1) {
            // $(`a[data-value='${input_primaryHpwhConfig.val()}'], a[data-value='${input_primaryHpwhConfig.val()}'] .btn`).toggleClass('toggled').trigger('blur');
            $(input_primaryHpwhConfig).val(schematic_value);
            $(`a[data-value='${schematic_value}'], a[data-value='${schematic_value}'] .btn`).toggleClass('toggled').trigger('blur');
            if (schematic_value === "single_pass") {
                $('#HPWHModel_single_pass').removeClass('d-none');
                $('#HPWHModel_multi_pass').addClass('d-none');
            } else if (schematic_value === "multi_pass") {
                $('#HPWHModel_single_pass').addClass('d-none');
                $('#HPWHModel_multi_pass').removeClass('d-none');
            }
        } else {
            // $(`a[data-value='${input_field.val()}'], a[data-value='${input_field.val()}'] .btn`).toggleClass('toggled').trigger('blur');
            $(input_field).val(schematic_value);
            $(`a[data-value='${schematic_value}'], a[data-value='${schematic_value}'] .btn`).toggleClass('toggled').trigger('blur');
        }
    }


    // loops through all buttons and adds description tags only on initial page load
    if (!schematic_value){
        $('.js-schematic-btn').each(function (index, element) {
            data_value = $(this).attr('data-value');
            // if (data_value === schematic_value ||  data_value === input_primaryHpwhConfig.val()) {
            //     $(this).addClass('toggled').trigger('blur');
            //     $('.btn', this).addClass('toggled');
            // }

            if (inputs[data_value].desc) {
                /* get description, if definition, wrap in link to launch help panel */
                let description = inputs[data_value].desc;
                /* if definition available and desc does not have class = no-help */
                if (inputs[data_value].definition) {
                    let helpIcon = `<i class="symbol help left"><object tabindex="-1" type="image/svg+xml" data="/static/build/gfx/svg/symbol-help${gfx_ext}.svg"></object><object class="help-hover" tabindex="-1" type="image/svg+xml" data="/static/build/gfx/svg/symbol-help-hover${gfx_ext}.svg"></object></i>`;
                    description = `<span data-help="inputs-${data_value}">${helpIcon}${description}</span>`;
                }

                /* if tag exists */
                if ($(this).siblings('.suffix-wrap').length) {
                    $(this).siblings('.suffix-wrap').find('p.desc').html(description).addClass('visible');
                }
                $(this).siblings('.suffix-wrap').find('p.locked')
            }
        });
    }

    // now adjust if on annual simulation
    if ((!schematic_value && input_primaryHpwhConfig ) || (input_primaryHpwhConfig && primaryHPWHChoices.indexOf(schematic_value)> -1)){
        // then disable buttons with respect to single/multi pass
        // Default to single_pass if no value set
        let primaryConfigVal = input_primaryHpwhConfig.val() || "single_pass";
        if (primaryConfigVal == "single_pass") {
            primaryConfig.multi_pass.forEach( (ele) => {
                let mp_ele = $(`a[data-value="${ele}"]`);
                mp_ele.closest('.schematic-option').addClass("disabled");
                if (mp_ele.hasClass('toggled')) {
                    // need to untoggle it since not valid if single pass selected
                    mp_ele.removeClass('toggled').trigger('blur');
                    mp_ele.find('.btn').removeClass('toggled');
                    //set the input value blank
                    input_field.val("");
                }
            });
            primaryConfig.single_pass.forEach( (ele) => {
                $(`a[data-value="${ele}"]`).closest('.schematic-option').removeClass('disabled');
            })
        // else multipass
        } else {
            primaryConfig.single_pass.forEach( (ele) => {
                let sp_ele = $(`a[data-value="${ele}"]`);
                sp_ele.closest('.schematic-option').addClass('disabled');
                if (sp_ele.hasClass('toggled')) {
                    // need to untoggle it since not valid if multi pass selected
                    sp_ele.removeClass('toggled').trigger('blur');
                    sp_ele.find('.btn').removeClass('toggled');
                    //set the input value blank
                    input_field.val("");
                }
            });
            primaryConfig.multi_pass.forEach( (ele) => {
                $(`a[data-value="${ele}"]`).closest('.schematic-option').removeClass('disabled');
            });
        }
    }

    /* hide advanced options when viewing primary option */
    // Only do if on regular sizer not annual simulation page
    if (!input_primaryHpwhConfig) {
        if (tempSchmaticVal == 'singlepass_norecirc') {
            $('.advanced-options', fieldSet).addClass('hide');
        } else {
            $('.advanced-options', fieldSet).removeClass('hide');
        }


        /* reveal advanced fieldgroup related to schematic */
        $('.adv-option-groups .fieldgroup', fieldSet).addClass('closed');
        $('.adv-option-groups #group-' + tempSchmaticVal, fieldSet).removeClass('closed');

        /* show swing tank fields in parallel too */
        if (tempSchmaticVal === 'paralleltank') {
            $('.adv-option-groups #group-swingtank', fieldSet).removeClass('closed');
        }
    } else if (schematic_value === "single_pass"  || input_primaryHpwhConfig.val() === "single_pass") {
        // else if it is on annual sim page keep copy of multipass or single pass load shift dom elements
        if ($('#mploadshift').length) {
            MultiPassLSElement = $('#mploadshift').detach();
        }

        if (SinglePassLSElement) {
            SinglePassLSElement.appendTo("#annualSimLoadShift");
            SinglePassLSElement = null;
        }
    } else if (schematic_value === "multi_pass" || input_primaryHpwhConfig.val() === "multi_pass") {
        if ($('#sploadshift').length) {
            SinglePassLSElement = $('#sploadshift').detach();
        }

        if (MultiPassLSElement) {
            MultiPassLSElement.appendTo("#annualSimLoadShift");
            MultiPassLSElement = null;
        }

    }

    // Multi Pass - Return to Primary: lock Normal loadshift fields and Building Type
    const mprtpFields = ['aquastatFraction', 'lsNorm_TempSetOnTrig', 'lsNorm_TempSetOffTrig', 'storageT', 'offSensor_normal'];
    // Default values for mprtp Normal row
    const mprtpDefaults = {
        'aquastatFraction': 40,
        'lsNorm_TempSetOnTrig': 115,
        'lsNorm_TempSetOffTrig': 140,
        'storageT': 150,
        'offSensor_normal': 35
    };

    if (tempSchmaticVal === "mprtp") {
        // Set Normal loadshift fields to mprtp defaults and lock them
        Object.keys(mprtpDefaults).forEach(function(fieldName) {
            const field = $(`input[name="${fieldName}"]`);
            if (field.length) {
                field.val(mprtpDefaults[fieldName]);
                field.prop('readonly', true).attr('tabindex', '-1');
                field.parents('.field-wrap').addClass('locked').removeClass('js-error warning warning-expmin warning-expmax');
            }
        });

        // Lock Building Type to Multifamily
        $('#bld-choice').val('multi_family').prop('disabled', true);
        $('#bld-choice').parents('.field-wrap').addClass('locked');
    }
}

function initRLHLmethod() {
    /* initialize the toggle element based on value of input */
    const inputField = $('input[name=RLHLmethod]', '#form_ecosizer');
    let inputValue = $(inputField).val();
    let toggle_on = false; 

    /* let's check the input value and then set toggle value */
    if (inputValue === 'Recirculation Loop') {
        toggle_on = true;            
    }    
    
    toggleRLHLmethod(toggle_on);    
}

function toggleRLHLmethod(toggle_on) {
    
    const inputField = $('input[name=RLHLmethod]', '#form_ecosizer');
    let inputValue = $(inputField).val();

    /* if parameter not provided */
    if (toggle_on === undefined) {
        /* let's check the input value and then set toggle value */
        if (inputValue === 'Watts/Apt.') {
            toggle_on = true;            
        }        
    }

    const fieldGroup = $('#fields-RLHLmethod');

    if (toggle_on) {
        /* toggle button */
        $(".js-btn-toggle", fieldGroup).addClass("toggled");

        /* enable fields */
        unlockFields(['recircFlow', 'recircTemp']);
        lockFields(['Wapt']);
        
        inputValue = 'Recirculation Loop';
    } else {
        /* toggle button */ 
        $(".js-btn-toggle", fieldGroup).removeClass("toggled");

        /* reset & disable fields */
        $('input[name=recircFlow]', '#form_ecosizer').val("");
        $('input[name=recircTemp]', '#form_ecosizer').val("");
        unlockFields(['Wapt']);
        lockFields(['recircFlow', 'recircTemp']);

        inputValue = 'Watts/Apt.';
    } 

    /* insert method to input value */ 
    $(inputField).val(inputValue);
}


function bedroomsHaveError() {
    let bedroomsError = false;
    /* if any of the fields contain error return immediately */
    $('[name^="nBR"]', '#form_ecosizer').each(function () {
        if ($(this).parents('.field-wrap').hasClass('js-error'))
            bedroomsError = true;
    });
    return bedroomsError;
}

function getBedrooms() {
    let bedroomValues = [];
    $('[name^="nBR"]', '#form_ecosizer').each(function () {
        bedroomValues.push(Number($(this).val()));
    });

    return bedroomValues;
}

function sumBedrooms() {
    const bedroomValues = getBedrooms();

    let sum = bedroomValues.reduce(function (accumulator, currentValue) {
        return accumulator + currentValue;
    }, 0);
    return sum;
}

function calculateRLHL() {
    const nBR5 = $('input[name=nBR5]', '#form_ecosizer');
    const nBR4 = $('input[name=nBR4]', '#form_ecosizer');
    const nBR3 = $('input[name=nBR3]', '#form_ecosizer');
    const nBR2 = $('input[name=nBR2]', '#form_ecosizer');
    const nBR1 = $('input[name=nBR1]', '#form_ecosizer');
    const nBR0 = $('input[name=nBR0]', '#form_ecosizer');
    const inputMethod = $("input[name=inputmethod]", "#form_ecosizer").val();
    let countApts = Number($('input[name=nApt]', '#form_ecosizer').val());
    if (inputMethod != "NPep") {
        countApts = sumBedrooms();
    }
    /* make sure we have numbers for Apts */
    if (countApts < 1) return;
    if (countApts < 12) {
        $(nBR5).parents('.field-wrap').addClass('warning warning-expmin');
        $(nBR4).parents('.field-wrap').addClass('warning warning-expmin');
        $(nBR3).parents('.field-wrap').addClass('warning warning-expmin');
        $(nBR2).parents('.field-wrap').addClass('warning warning-expmin');
        $(nBR1).parents('.field-wrap').addClass('warning warning-expmin');
        $(nBR0).parents('.field-wrap').addClass('warning warning-expmin');
    } else {
        $(nBR5).parents('.field-wrap').removeClass('warning warning-expmin');
        $(nBR4).parents('.field-wrap').removeClass('warning warning-expmin');
        $(nBR3).parents('.field-wrap').removeClass('warning warning-expmin');
        $(nBR2).parents('.field-wrap').removeClass('warning warning-expmin');
        $(nBR1).parents('.field-wrap').removeClass('warning warning-expmin');
        $(nBR0).parents('.field-wrap').removeClass('warning warning-expmin');
    }

    if ($('input[name=RLHLmethod]', '#form_ecosizer').val() === "Watts/Apt.") return;

    const recircTemp = $('input[name=recircTemp]', '#form_ecosizer');
    const recircTemp_val = Number($(recircTemp).val());
    const recircFlow = $('input[name=recircFlow]', '#form_ecosizer');
    const recircFlow_val = Number($(recircFlow).val());
    const supplyT = Number($('input[name=supplyT]', '#form_ecosizer').val());

    /* if either of the fields are not complete or has min/max error, abort */
    if (typeof recircTemp_val != "number" || $(recircTemp).parents('.field-wrap').is('.js-error')) return;
    if (typeof recircFlow_val != "number" || $(recircFlow).parents('.field-wrap').is('.js-error')) return;


    /* if Custom Load Only, we don't have Apts value, set value to absolute min */
    if ($('input[name="customLoadMethod"]').val() === 'onlyCL') {
        // const minWaptValue = $('input[name=Wapt]', '#form_ecosizer').attr('min');
        // $('input[name=Wapt]', '#form_ecosizer').val(minWaptValue).change().blur();

        $('input[name=Wapt]', '#form_ecosizer').val('').change().blur();
        return;  
        /* exit */
    }

    
    const recircDelta = supplyT - recircTemp_val;
    const recircFlowHr = recircFlow_val * 60; //60 minutes

    const BTUapt = 8.4 * recircFlowHr * (recircDelta / countApts);
    const Wapt = BTUapt / 3.412;

    /* focus/blur to trigger field actions and styles */
    $('input[name=Wapt]', '#form_ecosizer').val(parseInt(Wapt.toFixed(2))).change().blur();

    /* validate min/max values */
    checkMinMax($('input[name=Wapt]', '#form_ecosizer'));
}

// function toggleCA_spec(toggle_on) {
//     // TODO add this input to django so we know if user selected on results 
//     const inputField = $('input[name=CAspec]', '#form_ecosizer');
//     const button = $("#toggle-ca_spec");

//     if (toggle_on) {
//         $(inputField).attr('checked', true);
//         $(button).addClass("toggled");
//         CA_spec_mode();        
//     } else {
//         $(inputField).attr('checked', false);
//         $(button).removeClass("toggled");
//     }
// }

function toggleInputMethod(method) {
    /* if method provided */
    const inputField = $('input[name=inputmethod]', '#form_ecosizer');
    let inputValue = $(inputField).val();
    if (method) {
        if (method === inputValue) return;

        inputValue = method;
        /* insert method to input value */
        $(inputField).val(method);
    }

    const fieldSet = $(inputField).parents('fieldset')[0];
    
    // if (method === "NPep" || method === undefined) {
    //     $("#fieldgroup-RPep").addClass("closed");
    // }
    // else if (method === "RPep") {
    //     // Close NPep element if RPep method selected
    //     $("#fieldgroup-NPep").addClass("closed");
    // }
    const target = "#fieldgroup-" + inputValue;

    /* close all fieldgroups in this fieldset */
    // Removed cause made no sense and was causing errors
    $(".fieldgroup", fieldSet).addClass("closed");

    /* toggle target fieldgroup */
    $(target).removeClass("closed");

    /* now update UI to reflect changes */
    /* reset all buttons in group */
    $(".js-btn-option", fieldSet).removeClass("toggled").blur();

    /* toggle this button on */
    $("button[data-value=" + inputValue + "]", fieldSet).addClass("toggled").blur();

    // if (method === "NPep") {
    //     /* if Number of People method is selected, disable california spec */
    //     toggleCA_spec();
    // }
}

function updateLoadshift(values) {
    const meta = $('.meta-loadshift');
    const metaPeriod1 = $('.meta-period.LSperiod1');
    const metaPeriod2 = $('.meta-period.LSperiod2');

    if (values.length && !$(metaPeriod1).hasClass('disabled')) {
        $('.range', metaPeriod1).html(values[0] + '–' + values[1]);
        $('input[name=LSperiod1]', '#form_ecosizer').val(values[0] + ',' + values[1]);
    } else {
        $('input[name=LSperiod1]', '#form_ecosizer').val("");
    }

    /* if second range is available */
    if (values.length > 2 && !$(metaPeriod2).hasClass('disabled')) {
        $('.range', metaPeriod2).html(values[2] + '–' + values[3]);
        $('input[name=LSperiod2]', '#form_ecosizer').val(values[2] + ',' + values[3]);
    } else {
        $('input[name=LSperiod2]', '#form_ecosizer').val("");
    }
}

function toggleLoadshift(toggle_on) {
    const inputField = $('input[name=loadShift]', '#form_ecosizer');
    const button = $("#toggle-loadshift");
    const fieldSet = $(button).parents('fieldset')[0];
    const target = $("#fieldgroup-loadshift");

    /* close all fieldgroups in this fieldset */
    $(".fieldgroup", fieldSet).addClass("disabled");

    /* if not checked, or if force on */
    if (!$(inputField).is(':checked') || toggle_on) {

        $(inputField).attr('checked', true);
        $(button).addClass("toggled");

        /* toggle target fieldgroup */
        $(target).removeClass("disabled");
    } else {
        $(inputField).attr('checked', false);
        $(button).removeClass("toggled");

        /* toggle target fieldgroup */
        $(target).addClass("disabled");
    }
}

function setWaterSliders(value) {
    const fieldGroup = $('#fieldgroup-RPep');

    /* untoggle CA button */
    $("#toggle-ca_bedroom").removeClass('toggled');

    /* hide calculation summary */
    $("#fieldgroup-RPep").removeClass('ca_mode');

    /* show sliders */
    $('.slider-water', fieldGroup).attr('disabled', false).find('.noUi-handle').attr('tabindex', '');
    $('.slider-water', '#fieldgroup-RPep').parents('.field-wrap').removeClass('hide');

    /* restore RBR inputs */
    enableRBR_fields();

    /* exit if no value supplied */
    if (typeof value != "number") return;

    $('.slider-water', fieldGroup).each(function () {
        let sliderID = $(this).attr('id');
        sliderID = document.getElementById(sliderID);
        sliderID.noUiSlider.set(value);
    });
}

function lockWaterSliders() {

    /* toggle CA button */
    $("#toggle-ca_bedroom").addClass('toggled');

    /* indicate locked water sliders */
    $("#fieldgroup-RPep").addClass('ca_mode');

    /* disable RBR fields */
    disableRBR_fields();

    $('.slider-water', '#fieldgroup-RPep').attr('disabled', true).find('.noUi-handle').attr('tabindex', '-1');
    $('.slider-water', '#fieldgroup-RPep').parents('.field-wrap').addClass('hide');

    /* fetch initial value and reveal calculation summary */
    fetchGPDPP();
}



function checkMinMax(inputField) {
    /* skip for water sliders */
    const fieldWrap = $(inputField).parents('.field-wrap');
    //if ($('.slider-water', fieldWrap).length !== 0) return;

    /* skip for locked fields or fields with django error */
    if ($(fieldWrap).is('.locked')) return;

    const input = Number($(inputField).val());
    const AbsMin = Number($(inputField).attr('min'));
    const AbsMax = Number($(inputField).attr('max'));
    const ExpMin = (Number($(inputField).attr('data-expmin')) ? Number($(inputField).attr('data-expmin')) : 0);
    const ExpMax = (Number($(inputField).attr('data-expmax')) ? Number($(inputField).attr('data-expmax')) : 0);

    if (typeof input != "number") return;

    let errorMsg = "";
    let restrictValue = false;
    let warning = false;

    /* valdiate absolute values */
    if (input < 0 || input < AbsMin) {
        /* auto-correct value to use ExpMin, or AbsMin as fallback */
        restrictValue = (ExpMin ? ExpMin.toString() : AbsMin.toString());
        errorMsg = `Must be ${AbsMin} or higher.`;
    }
    /* check if value is falsey first */
    if (AbsMax != 0 && input > AbsMax) {
        restrictValue = (ExpMax ? ExpMax.toString() : AbsMax.toString());
        errorMsg = `Must be ${AbsMax} or lower.`;
    }

    if (restrictValue) {
        //$(inputField).val(restrictValue);
        symbol = `<i class="symbol help left"><object tabindex="-1" type="image/svg+xml" data="/static/build/gfx/svg/symbol-error${gfx_ext}.svg"></object><object class="help-hover" tabindex="-1" type="image/svg+xml" data="/static/build/gfx/svg/symbol-error-hover${gfx_ext}.svg"></object></i>`;
        $(inputField).parents('.field-wrap').addClass('js-error').find('.suffix-wrap p.js-errors').html(symbol + errorMsg);
        return;
    }

    /* if no absolute errors, validate expected values */
    if (input < ExpMin) {
        warning = true;
        $(inputField).parents('.field-wrap').addClass('warning warning-expmin');
    }
    /* check if value is falsey first */
    if (ExpMax != 0 && input > ExpMax) {
        warning = true;
        $(inputField).parents('.field-wrap').addClass('warning warning-expmax');
    }
    /* if no warning, remove classes */
    if (!warning) {
        $(inputField).parents('.field-wrap').removeClass('warning warning-expmin warning-expmax');
    }
}

function getLSPeriodValues(period) {
    /* get current values from LSPeriods inputs, if val not availabe get preset from JSON */
    const periodVal = $('input[name=' + period + ']', '#form_ecosizer').val();
    let string = (periodVal ? periodVal : inputs[period].default);
    let array = [];

    if (string.length) {
        array = string.replace(/, +/g, ",").split(",").map(Number);
    }
    return array;
}

function createLoadshiftSlider() {

    /* if no Loadshift section, exit */
    if ($('#fs-loadshift').length != 1) return;

    let val_LSperiod1 = getLSPeriodValues("LSperiod1");
    let val_LSperiod2 = getLSPeriodValues("LSperiod2");
    let loadShiftHandles = val_LSperiod1.concat(val_LSperiod2);

    let slider_loadShift = document.getElementById('slider_loadShift');
    noUiSlider.create(slider_loadShift, {
        range: {
            'min': 0,
            'max': 24
        },

        step: 1,
        //step: 0.25, //15min increments

        // Handles start at ...
        start: loadShiftHandles,

        // ... must be at least this apart
        margin: 1,
        //margin: 0.25,

        // ... but no more than this
        limit: 24,

        // Display colored bars between handles
        connect: [false, true, false, true, false],

        // Put '0' at the bottom of the slider
        //direction: 'rtl',
        orientation: 'horizontal',

        // Move handle on tap, bars are draggable
        behaviour: 'tap-drag',
        tooltips: false,

        // Show a scale with the slider
        pips: {
            mode: 'steps',
            stepped: true,
            density: 8
        },
        format: {
            // 'to' the formatted value. Receives a number.
            to: function (value) {
                return Number(Math.floor(value));
            },
            // 'from' the formatted value.
            // Receives a string, should return a number.
            from: function (value) {
                return Number(Math.floor(value));
            }
        }
    });

    /* events: 'start' > 'slide' > 'update' > 'change' > 'set' > 'end' */
    /* params: values, handle, unencoded, tap, positions, noUiSlider */
    slider_loadShift.noUiSlider.on('update', function (values) {
        updateLoadshift(values);
    });

    /* toggle off the period if bool is not checked */
    if (!$('input[name=LSperiod1_bool]', '#form_ecosizer').is(':checked')) {
        disableLoadShiftPeriod("LSperiod1");
    }
    if (!$('input[name=LSperiod2_bool]', '#form_ecosizer').is(':checked')) {
        disableLoadShiftPeriod("LSperiod2");
    }
}

function createLoadshiftPercentSlider() {

    /* if no Loadshift section, exit */
    if ($('#fs-loadshift').length != 1) return;

    /* get val from input field, if none use default from JSON */
    let val_loadShift_percent = $('input[name=loadShift_percent]').val();
    val_loadShift_percent = (val_loadShift_percent ? val_loadShift_percent : inputs.loadShift_percent.default);

    const slider_loadShift_percent = document.getElementById('slider_loadShift_percent');
    noUiSlider.create(slider_loadShift_percent, {
        range: {
            'min': 25,
            'max': 100
        },
        step: 1,

        // Handles start at ...
        start: [val_loadShift_percent],

        // Display colored bars between handles
        connect: [true, false],

        // Move handle on tap, bars are draggable
        behaviour: 'tap-drag',
        tooltips: true,

        // Show a scale with the slider
        pips: {
            mode: 'values',
            values: [25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100],
            density: 10,
            filter: function (value) {
                if (value === 25 || value === 100) {
                    return 1; //make value large size 
                }
                return 2; //make value small size 
            }
        },
        format: {
            // 'to' the formatted value. Receives a number.
            to: function (value) {
                return Math.ceil(value);
            },
            // 'from' the formatted value.
            // Receives a string, should return a number.
            from: function (value) {
                return Math.ceil(value);
            }
        }
    });

    slider_loadShift_percent.noUiSlider.on('update', function (values) {
        $('input[name=loadShift_percent]', '#form_ecosizer').val(values);

        /* adjust clipping path */
        /* position of right edge is inversed (e.g. 100% means right edge is at far left)*/

        //clipPos = (100) - values;
        /* our range is 25-100, so we need to do some math to get the mask position (0-100%) correct */
        clipPos = 100 - Math.ceil((values - 25) * 1.3333);
        opacity = (Math.ceil((values - 25) * 1.3333) / 100);
        $('.expocurve.mask').attr('style', `clip-path: inset(0 ${clipPos}% 0 0)`);
        $('.expocurve.mask').css('opacity', opacity);

    });

    clipPos = 100 - Math.ceil((val_loadShift_percent - 25) * 1.3333);
    opacity = (Math.ceil((val_loadShift_percent - 25) * 1.3333) / 100);
    $('#slider_loadShift_percent').append(`<object class="expocurve mask" style="clip-path: inset(0 ${clipPos}% 0 0); opacity:${opacity}" tabindex="-1" type="image/svg+xml" data="/static/build/gfx/expo_curve-mask.svg"></object>`);
    $('#slider_loadShift_percent').append(`<object class="expocurve" tabindex="-1" type="image/svg+xml" data="/static/build/gfx/expo_curve.svg"></object>`);
    $('#slider_loadShift_percent').append(`<object class="expocurve-label" tabindex="-1" type="image/svg+xml" data="/static/build/gfx/expo_curve-label.svg"></object>`);
}

function enableLoadShiftPeriod(period) {
    const periodMeta = $('.meta-period.' + period);
    $('input[type=checkbox]', periodMeta).attr('checked', true);

    $(periodMeta).removeClass("disabled");
    $('.js-btn-toggle', periodMeta).addClass("toggled");

    let handleValues = getLSPeriodValues(period);
    let nullValues = [null, null];
    if (period === "LSperiod1") {
        /* set values for Period1 only */
        handleValues = handleValues.concat(nullValues);
        $('#slider_loadShift .noUi-origin').eq(0).attr('disabled', false).removeClass('hide');
        $('#slider_loadShift .noUi-origin').eq(1).attr('disabled', false).removeClass('hide');
        $('#slider_loadShift .noUi-connect').eq(0).attr('disabled', false).removeClass('hide');
    } else {
        /* set values for Period2 only */
        handleValues = nullValues.concat(handleValues);
        $('#slider_loadShift .noUi-origin').eq(2).attr('disabled', false).removeClass('hide');
        $('#slider_loadShift .noUi-origin').eq(3).attr('disabled', false).removeClass('hide');
        $('#slider_loadShift .noUi-connect').eq(1).attr('disabled', false).removeClass('hide');
    }

    slider_loadShift.noUiSlider.set(handleValues);
}

function disableLoadShiftPeriod(period) {
    const periodMeta = $('.meta-period.' + period);
    $('input[type=checkbox]', periodMeta).attr('checked', false);

    $(periodMeta).addClass("disabled");
    $('.js-btn-toggle', periodMeta).removeClass("toggled");

    let handleValues = [];
    if (period === "LSperiod1") {
        /* set values for Period1 only */
        handleValues = [0, 1, null, null];
        $('#slider_loadShift .noUi-origin').eq(0).attr('disabled', true).addClass('hide');
        $('#slider_loadShift .noUi-origin').eq(1).attr('disabled', true).addClass('hide');
        $('#slider_loadShift .noUi-connect').eq(0).attr('disabled', true).addClass('hide');
    } else {
        /* set values for Period2 only */
        handleValues = [null, null, 23, 24];
        $('#slider_loadShift .noUi-origin').eq(2).attr('disabled', true).addClass('hide');
        $('#slider_loadShift .noUi-origin').eq(3).attr('disabled', true).addClass('hide');
        $('#slider_loadShift .noUi-connect').eq(1).attr('disabled', true).addClass('hide');
    }

    slider_loadShift.noUiSlider.set(handleValues);
}


function openHelpPanel(keyName, fieldName, helpElement) {

    /* look for keyname in inputs JSON */
    if (!(fieldName in jsonData[keyName])) return;
    const term = jsonData[keyName][fieldName];
    let errorsHTML = "";
    let errorHasNumber = false;
    let warningHTML = "";
    let helpHTML = "";

    /* check for errors first, then check for warnings, then append help text */
    const inputField = $(`input[name=${fieldName}]`, '#form_ecosizer');
    const parent = $(inputField).parents('.field-wrap');
    if (parent) {
        //if ($(parent).hasClass('error') && $(parent).find('ul.errorlist').length !== 0) {
        if ($(parent).hasClass('error')) {
            errorsTitle = `<h6 class="icon-label color-error"><i class="symbol left"><object tabindex="-1" type="image/svg+xml" data="/static/build/gfx/svg/symbol-error${gfx_ext}.svg"></object></i>Error</h6>`;
            errorsHTML = '<div class="block help-error">' + errorsTitle;
            errorsHTML += '<p>';

            /* get Django errors */
            if ($(parent).find('ul.errorlist').length !== 0) {
                $('ul.errorlist li', parent).each(function () {
                    if (hasNumber($(this).text())) {
                        errorHasNumber = true;
                    }
                    errorsHTML += ' ' + $(this).html();
                });
            }

            /* concat JS errors, only if django error does not contain numbers */
            if (errorHasNumber == false && !$(parent).find('p.js-errors').is(':empty')) {
                errorsHTML += ' ' + $(parent).find('p.js-errors').text();
            }

            errorsHTML += '</p>';
            errorsHTML += '</div>';
        }

        /* check for warning classes */
        if ($(parent).hasClass('warning')) {
            warningTitle = `<h6 class="icon-label color-warning"><i class="symbol left"><object tabindex="-1" type="image/svg+xml" data="/static/build/gfx/svg/symbol-warning${gfx_ext}.svg"></object></i>Warning</h6>`;
            warningHTML = '<div class="block help-warning">' + warningTitle;

            /* get exp min warning msg */
            if ($(parent).hasClass('warning-expmin')) {
                warningHTML += '<p>' + jsonData[keyName][fieldName].warningMin + '</p>';
            }
            /* get exp max warning msg */
            if ($(parent).hasClass('warning-expmax')) {
                warningHTML += '<p>' + jsonData[keyName][fieldName].warningMax + '</p>';
            }

            warningHTML += '</div>';
        }
    }

    if (term.definition) {
        helpHTML = `<div class="block help-info">
                    <header>
                    ${ term.label ? `<h6>${term.label}</h6>` : "" }
                    ${ term.desc ? `<em>${term.desc}</em>` : "" }
                    </header>
                    ${term.definition ? term.definition : ""}
                    ${term.context ? term.context : ""}
                    </div>`;
    }

    /* now assemble the html */
    let panelHTML = `<div class="help-panel fade-in">    
    ${errorsHTML} 
    ${warningHTML} 
    ${helpHTML} 
    <button class="btn-close"><i class="symbol close"></i></button>
    </div>`;

    /* insert panel html into body */
    $('body').append(panelHTML);

    /* position the panel related to the element that launched it */
    positonPanel(fieldName, helpElement);

    /* destroy this listener after one event */
    setTimeout(function () {
        $(document).one("click", ".help-panel", function (e) {
            e.preventDefault();
            e.stopPropagation();
            $('.help-panel').remove();
            return false;
        });
    }, 100);
}

function positonPanel(keyName, helpElement) {
    /* figure out where to place this on page */
    const helpPanel = $('.help-panel');
    if (!helpPanel) return; //if panel does not exit, exit      

    /* we start assuming user clicked the short text below input */
    /* if the launching element is the input, we pos the help panel differently */
    /* btn-help is a free floating help icon not embeded with input */
    const forInput = ($(helpElement).is('input') ? true : false);
    const forHelpIcon = ($(helpElement).hasClass('btn-help') ? true : false);

    /* get properties of parent */
    let parentW = helpElement.outerWidth();
    let parentH = helpElement.outerHeight();
    let parentPos = [];
    parentPos.x = helpElement.offset().left;
    parentPos.y = helpElement.offset().top;

    /* get properties of panel */
    let panelW = helpPanel.outerWidth();
    //let panelH = helpPanel.outerHeight();

    /* now calculate the position of our panel */
    /* position panel centered to parent  */
    let panelPos = [];
    panelPos.x = parentPos.x + (parentW / 2) - (panelW / 4);
    panelPos.y = parentPos.y + 10;
    if (forInput) {
        panelPos.y = (parentPos.y + parentH) + 12;
    }
    if (forHelpIcon) {
        panelPos.y = (parentPos.y + parentH) + 32;
    }

    if ((panelPos.x + panelW + 8) > $(window).width()) {
        //panel exceeds window")
        panelPos.x = (parentPos.x + parentW) - panelW;
    }

    $(helpPanel).css({
        top: panelPos.y,
        left: panelPos.x
    });
}

function updateGPDPP(sum, error) {
    $('#calculated-gpdpp').addClass('active').removeClass('loading error').find('.sum').html(sum);

    if (error) {
        //console.log('updateGPDPP error')
        $('#calculated-gpdpp').addClass('error');
    }
}

function fetchGPDPP() {

    /* grab token from form input */
    const csrf_token = $('input[name=csrfmiddlewaretoken]').val();

    /* grab token from session cookie */
    //const csrf_cookie = getCookie('csrftoken');
    //console.log(csrf_cookie)  

    let bedroomValues = getBedrooms();
    const bedroomsHaveValues = bedroomValues.some(function (item) {
        return item > 0;
    });

    /* abort if all bedroom values are 0 */
    if (!bedroomsHaveValues) {
        //console.log('bedroomsHaveValues = false')
        return;
    }

    if (bedroomsHaveError()) {
        //console.log('bedroomsHaveError')
        updateGPDPP("0", true);
        return;
    }

    /* get values from bedroom inputs */
    let data_Bedrooms = JSON.stringify({
        data: bedroomValues
    });

    /* if bedroom values match prev fetch, exit early */
    if (prevBedroomValues.sort().toString() == bedroomValues.sort().toString()) return;

    /* update var  */
    prevBedroomValues = bedroomValues;
    $('#calculated-gpdpp').addClass('loading').removeClass('active');

    //fetchURL = 'https://dev-ecosizer.ecotope.com/sizer/cagpdpp/';
    const fetchURL = '/sizer/cagpdpp/';
    return fetch(fetchURL, {
            method: 'post',
            mode: 'same-origin', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            headers: {
                'X-CSRFToken': csrf_token,
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            },
            body: data_Bedrooms
        })
        .then(function (response) {
            // Handle the fetch Response object.

            if (!response.ok) {
                // Non-200-status response; throw here so it is handled in the catch.
                throw response;
            }

            // OK response, return the data.
            // Use text() instead of json() so we don't fail if json is not available.
            return response.text();
        })
        .then(function (text) {
            // Safely convert the response text to json.
            try {
                var json = JSON.parse(text);
                return json;
            } catch (e) {
                throw new Error('Failed to parse JSON:', text);
            }
        }).then(function (json) {
            if ("error" in json) {
                throw new Error(json.error);
            }
            /* send value to function and update UI */
            updateGPDPP(json.gpdpp);

        }).catch(function (err) {
            // Handle all types of errors in one place.

            // Remove the cached response to allow retries.
            //delete response_cache[url];

            /* update GPDPP with error message */
            updateGPDPP(0, true);

            if (err instanceof Response) {
                // The response was not successful (status not in the range 200-299).
                throw new Error('Unexpected response: ' + err.status, err.statusText);
            } else {
                // fetch() failed, such as network failure, or the JSON failed to parse.
                throw new Error('Exception in response: ' + err.message);
            }
        });
}

function radioGroup(btn) {
    var radioVal = $(btn).find("input").val();
    var parent = $(btn).parents('.radio-group');

    /* reset all radios */
    $(".btn-radio", parent).removeClass('toggled');
    $("input", parent).prop('checked', false);

    $('input:radio', parent).each(function (i) {
        /* if radio value matches selected value */
        if (radioVal === $(this).val()) {
            $(this).prop('checked', true);
            $(btn).addClass('toggled');

            /* assign radio button value to hidden input field */
            if ($('input[name="customLoadMethod"]', parent).length != 0) {
                $('input[name="customLoadMethod"]').val(radioVal);
                customLoadOptions(radioVal);
            }
        }
    });
}

function customLoadOptions(method) {
    /* for Custom Hot Water Load section */

    /* reset */
    $('.section-onlyCL').removeClass('active');
    $('#fs-CAspec').removeClass('hide');
    $('#fs-buildingType').removeClass('hide')
    $('#fs-inputmethod').removeClass('hide');
    $('input[name^="customLoad_"]').attr('disabled', false).parents('.field-wrap').removeClass('locked');
    $('#fields-RLHLmethod .js-btn-toggle').addClass("locked"); // force Flow Rate & Temp fields

    toggleRLHLmethod(true); // toggle Recirculation Loop method to use Flow Rate

    if (method === 'onlyCL') {
        let advancedOptionsPanel = $('input[name="recircFlow"]').parents('.advanced-options');

        $(advancedOptionsPanel).addClass("expanded");
        $('.js-adv-options', advancedOptionsPanel).addClass("toggled");
        /* disable input method, show locked section */
        $('.section-onlyCL').addClass('active');
        $('#fs-CAspec').addClass('hide');
        $('#fs-inputmethod').addClass('hide');
        $('#fs-buildingType').addClass('hide')

        CA_spec_mode(false); //turn off CA spec mode, and re-enable Parallel Loop Tank
    }
}

/* when the DOM and everything has finished loading */
$(function () {

    /* add suffix to SVGs for CalBEM */
    gfx_ext = ($('body').hasClass('calbem') ? "-calbem" : "");

    /* if viewing form page */
    if ($('#form_ecosizer').length) {

        /* get our properties for inputs, stored in external JSON */
        $.getJSON('/static/input-config.json', function (json) {
            if (typeof json.inputs === 'undefined') {
                throw new Error('Invalid json in getJSON');
            }
            /* save for later */
            jsonData = json;
            presets = json.presets;
            inputs = json.inputs;
            outputs = json.outputs;

            /* populate supporting elements in each field */
            Object.keys(json.inputs).forEach(function (key, input) {
                if (key === 'customLoad_hours') {
                    /* for Custom Hot Water Load section */
                    /* use a single input config from JSON instead of 24 keys */
                    for (let step = 0; step < 24; step++) {
                        if (step < 10) step = `0${step}`; /* zero prefix for numbers 0-9  */
                        inputName = `customLoad_${step}`;
                        populateField(inputName, json.inputs[key])
                        continue;
                    }
                }

                populateField(key, json.inputs[key]);
            });

            /* initialize and toggle fields based on user selections */
            setupFields();

            /* initialize sliders */
            createLoadshiftSlider();
            createLoadshiftPercentSlider();

        }).catch(function (err) {
            console.log(err);
        });
    }

});
